// Constants
import { Colors } from "@ms/uno-constants/lib/local/Colors";
import { PlannerTheme } from "@ms/uno-constants/lib/local/ThemeConstants";
// Styles
import { concatStyleSets, concatStyleSetsWithProps, memoizeFunction, NeutralColors } from "@fluentui/react";
import { highContrastBorders } from "../../../utilities/HighContrast.styles";
import { buttonFluentUIStyle, fontColorNeutralSecondary } from "../../../utilities/Mixin.styles";
import { getContextualMenuStyles } from "../../contextualMenu/ContextualMenu.styles";
import { getCheckboxStyleFunction } from "../checkbox/Checkbox.styles";
/**
 * Get custom styles for TaskDetailsAttachmentsSection control
 * @param theme App context theme
 * @param customStyles (optional) Any custom style overrides
 */ export const getCustomTaskDetailsAttachmentsSectionStyles = memoizeFunction((theme, customStyles)=>{
    const subComponentStyles = {
        contextualMenu: getContextualMenuStyles(theme),
        attachmentLabel: getAttachmentLabelStyles(theme),
        list: getAttachmentListStyles(theme),
        addAttachmentButton: buttonFluentUIStyle(theme)
    };
    const styles = {
        subComponentStyles
    };
    return concatStyleSets(styles, customStyles);
});
/**
 * Helper to get styles for task attachment label
 * @param theme App context theme
 */ const getAttachmentLabelStyles = memoizeFunction((theme)=>{
    const attachmentLabelStyles = {
        root: fontColorNeutralSecondary(theme)
    };
    return attachmentLabelStyles;
});
/**
 * Helper to get styles for task attachment show on card checkbox
 * @param theme App context theme
 */ const getShowOnCardStyles = memoizeFunction((theme)=>{
    const customCheckboxStyles = (props)=>{
        const isActiveState = props.checked && !props.disabled;
        const activeStyles = {
            "> .ms-Checkbox-label": [
                isActiveState && {
                    "> .ms-Checkbox-checkbox": [
                        theme.name === PlannerTheme.HighContrast && {
                            borderColor: Colors.Black,
                            backgroundColor: Colors.TeamsContrastHyperlinkColor,
                            "> .ms-Checkbox-checkmark": {
                                color: Colors.Black
                            }
                        }
                    ]
                }
            ]
        };
        const styles = {
            root: [
                activeStyles,
                {
                    ":hover, :active, :focus": activeStyles
                }
            ],
            checkmark: [
                theme.name === PlannerTheme.HighContrast && {
                    color: Colors.White
                }
            ]
        };
        return styles;
    };
    const defaultCheckboxStyles = getCheckboxStyleFunction(theme);
    const showOnCardStyles = (props)=>concatStyleSetsWithProps(props, defaultCheckboxStyles, customCheckboxStyles);
    return showOnCardStyles;
});
/**
 * Helper to get styles for task attachment list control
 * @param theme App context theme
 */ const getAttachmentListStyles = memoizeFunction((theme)=>{
    const leftContent = ()=>{
        switch(theme.name){
            case PlannerTheme.Dark:
                return {
                    border: "none"
                };
            case PlannerTheme.HighContrast:
                return {
                    ":hover": {
                        borderColor: Colors.TeamsContrastHyperlinkColor
                    }
                };
            default:
                return {};
        }
    };
    const attachmentChicklet = ()=>{
        switch(theme.name){
            case PlannerTheme.HighContrast:
                return {
                    borderColor: Colors.White,
                    backgroundColor: Colors.Black,
                    ":hover": {
                        backgroundColor: Colors.TeamsContrastHyperlinkColor,
                        borderColor: Colors.TeamsContrastHyperlinkColor,
                        color: Colors.Black
                    }
                };
            case PlannerTheme.Dark:
                return {
                    backgroundColor: NeutralColors.gray150,
                    ":hover": {
                        backgroundColor: NeutralColors.gray140
                    }
                };
            default:
                return {};
        }
    };
    const itemListTitleText = ()=>{
        switch(theme.name){
            case PlannerTheme.HighContrast:
                return {
                    color: "inherit"
                };
            case PlannerTheme.Dark:
                return {
                    color: Colors.White
                };
            default:
                return {};
        }
    };
    const itemListUrlText = ()=>{
        switch(theme.name){
            case PlannerTheme.HighContrast:
                return {
                    color: "inherit"
                };
            case PlannerTheme.Dark:
                return {
                    color: NeutralColors.gray60
                };
            default:
                return {};
        }
    };
    const listStyles = {
        subComponentStyles: {
            row: {
                content: [
                    theme.name === PlannerTheme.HighContrast && {
                        color: Colors.White
                    }
                ],
                leftContent: [
                    leftContent(),
                    highContrastBorders()
                ],
                attachmentChicklet: attachmentChicklet(),
                fallbackPreviewIcon: [
                    theme.name === PlannerTheme.HighContrast && {
                        color: "inherit"
                    }
                ],
                itemListTitleText: itemListTitleText(),
                itemListUrlText: itemListUrlText(),
                subComponentStyles: {
                    showOnCard: getShowOnCardStyles(theme),
                    contextualMenu: getContextualMenuStyles(theme)
                }
            }
        }
    };
    return listStyles;
});
